export default "__VITE_ASSET__6da2dcc3__"